import { Button } from '@app/components';
import Logo from '@app/assets/vertical-logo.svg?react';
import ThankYouImage from '@app/assets/illustrations/thank-you.png';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export const SignUpConfirmation = () => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  // Clean up localStorage after component mounts
  useEffect(() => {
    localStorage.removeItem('signupFormData');
    localStorage.removeItem('selectedPlan');
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-6 bg-gray-50">
      <Logo width={139} height={110} className="mb-auto" />

      <div className="bg-white text-center space-y-8 rounded-lg max-w-[600px] px-10 pt-12 pb-8 shadow-sm mb-auto">
        <div className="flex justify-center mb-6">
          <img
            src={ThankYouImage}
            alt="Thank you"
            className="w-38 h-38 object-contain"
          />
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl font-bold text-gray-900">
          Your registration was successful
          </h1>

          <p className="text-base text-[#8B919F] max-w-md mx-auto">
            We've sent a confirmation email to your inbox. Please check your
            email and follow the instructions to verify your account.{' '}
          </p>
        </div>

        <div className="flex flex-col gap-4 w-full">
          {showButton ? (
            <Button
              onClick={() => navigate('/')}
              className="w-full bg-blue-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Explore Echo Ratings
            </Button>
          ) : (
            <div className="w-full bg-gray-200 py-3 px-6 rounded-lg flex items-center justify-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-baseBlue"></div>
              <span className="ml-2 text-gray-600">Loading...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
